/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type EmergencyContactCreateDto = {
  /**
   * Client phone number including country code.
   */
  phoneNumber: string;
  /**
   * Client locale code
   */
  locale?: EmergencyContactCreateDto.locale;
  /**
   * Name of the emergency contact entered by device owner
   */
  name: string;
  /**
   * List of house ids to which emergency contact is assigned
   */
  houses: Array<number>;
};
export namespace EmergencyContactCreateDto {
  /**
   * Client locale code
   */
  export enum locale {
    EN = 'EN',
    LV = 'LV',
    NO = 'NO',
    FI = 'FI',
  }
}

